import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./AllStudents.css"; // Import CSS file

function AllStudents({ data }) {

  const [search, setSearch] = useState("");
  const [student,setstudent]=useState(data.students)
  const navigate=useNavigate()
  const viewDetails=(viewDetails,students)=>{
    navigate(`feeeasy/student/${viewDetails}`,{ state: { students } })
  }
  // Filter students based on the search input

  const filteredStudents = student?.filter((student) =>
    student.phone?.includes(search) // Adjusted field name to 'phone'
  );

  return (
    <div className="all-students">
      <h2>All Students</h2>
      <input
        type="text"
        placeholder="Search by phone number"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className="search-input"
      />
      <table className="student-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Email</th>
            <th>Phone Number</th>
            <th>Details</th>
          </tr>
        </thead>
        <tbody>
          {filteredStudents?.length > 0 ? (
            filteredStudents.map((student) => (
              <tr key={student._id}>
                <td>{student._id}</td>
                <td>
                  {student.firstName} {student.lastName}
                </td>
                <td>{student.email}</td>
                <td>{student.phone}</td>
                <td>
                  <button onClick={()=>viewDetails(student._id,student)}>
                    View Details
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5" style={{ textAlign: "center" }}>
                No students found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default AllStudents;
